import { adminBlogRoutes } from './admin-blog-routes';
import { Routes } from '@angular/router';
import { moduleConfig } from 'src/app/core/models/module-config';
import { RokezzzAclMatcherService } from 'src/app/rokezzz/user/services/acl-matcher.service';
import { navbarItems } from './navbar-items';
import { adminContentRoutes } from './admin-content-routes';
import { adminOfferRoutes } from './admin-offer-routes';

export const basicAdminRoutes: Routes = [
    {
        path: $localize`:@@adminPath:admin`,
        canMatch: [RokezzzAclMatcherService.isLoggedIn],
        loadComponent: () => import('src/app/rokezzz/panel-menu/views/panel/panel.component').then(module => module.RokezzzPanelViewComponent),
        data: {
            path: 'admin',
            navbarItems: navbarItems,
        },
        children: [
            {
                path: '',
                loadComponent: () => import('src/app/rokezzz/panel-menu/views/panel/dashboard/dashboard.component').then(module => module.RokezzzDashboardViewComponent),
                data: {
                    path: 'admin.dashboard',
                }
            },
            ...(moduleConfig.isBlogEnabled ? [...adminBlogRoutes] : []),
            ...(moduleConfig.isSettingsEnabled ? [...adminContentRoutes] : []),
            ...(moduleConfig.isProductEnabled ? [...adminOfferRoutes] : []),
            ...(moduleConfig.isNewsletterEnabled ? [
                {
                    path: $localize`:@@adminNewsletterPath:newsletter`,
                    loadComponent: () => import('src/app/rokezzz/newsletter/views/newsletter/newsletter.component').then(module => module.RokezzzNewsletterViewComponent),
                    data: {
                        path: 'admin.newsletter'
                    }
                }
            ] : []),
            ...(moduleConfig.isReservationEnabled ? [
                {
                    path: $localize`:@@adminReservationPath:rezerwacje`,
                    loadComponent: () => import('src/app/rokezzz/reservation/views/reservation/reservation.component').then(module => module.RokezzzReservationViewComponent),
                    data: {
                        path: 'admin.reservation'
                    },
                    children: [
                        {
                            path: $localize`:@@adminReservationListPath:lista`,
                            loadComponent: () => import('src/app/rokezzz/reservation/views/reservation/list/list.component').then(module => module.RokezzzReservationListViewComponent),
                            data: {
                                path: 'admin.reservation.list'
                            }
                        }
                    ]
                },
                {
                    path: $localize`:@@adminSchedulePath:grafik`,
                    loadComponent: () => import('src/app/rokezzz/schedule/views/schedule/schedule.component').then(module => module.RokezzzScheduleViewComponent),
                    data: {
                        path: 'admin.schedule'
                    },
                    children: [
                        {
                            path: $localize`:@@adminScheduleListPath:lista`,
                            loadComponent: () => import('src/app/rokezzz/schedule/views/schedule/list/list.component').then(module => module.RokezzzListViewComponent),
                            data: {
                                path: 'admin.schedule.list'
                            }
                        }
                    ]
                }
            ] : []),
            ...(moduleConfig.isBlogEnabled || moduleConfig.isProductEnabled || moduleConfig.isSettingsEnabled ? [
                {
                    path: $localize`:@@adminImagePath:obrazki`,
                    loadComponent: () => import('src/app/rokezzz/file-upload/views/image/image.component').then(module => module.RokezzzImageViewComponent),
                    data: {
                        path: 'admin.image',
                    },
                    children: [
                        {
                            path: $localize`:@@adminImageListPath:lista`,
                            loadComponent: () => import('src/app/rokezzz/file-upload/views/image/list/list.component').then(module => module.RokezzzImageListViewComponent),
                            data: {
                                path: 'admin.image.list',
                            },
                        },
                    ]
                },
            ] : []),
            {
                path: $localize`:@@adminSettingsPath:ustawienia`,
                loadComponent: () => import('src/app/rokezzz/panel-menu/views/panel/settings/settings.component').then(module => module.RokezzzSettingsViewComponent),
                data: {
                    path: 'admin.settings'
                },
                children: [
                    {
                        path: $localize`:@@adminPasswordPath:hasła`,
                        loadComponent: () => import('src/app/rokezzz/panel-menu/views/panel/settings/password/password.component').then(module => module.RokezzzPasswordViewComponent),
                        data: {
                            path: 'admin.settings.password'
                        }
                    },
                    ...(moduleConfig.isDeleteUserOptionEnabled ? [
                        {
                            path: $localize`:@@adminAdvancedPath:zaawansowane`,
                            loadComponent: () => import('src/app/rokezzz/panel-menu/views/panel/settings/advanced/advanced.component').then(module => module.AdvancedComponent),
                            data: {
                                path: 'admin.settings.advanced'
                            }
                        }
                    ] : []),
                ]
            },
            {
                path: '**',
                redirectTo: $localize`:@@adminPath:admin`,
            },
        ],
    },
    {
        path: $localize`:@@adminPath:admin`,
        canMatch: [RokezzzAclMatcherService.isLoggedOut],
        children: [
            {
                path: $localize`:@@adminLoginPath:login`,
                loadComponent: () => import('src/app/rokezzz/user/views/login/login.component').then(module => module.RokezzzLoginViewComponent),
                data: {
                    path: 'admin.login'
                }
            },
            {
                path: '**',
                redirectTo: $localize`:@@adminPath:login`,
            }
        ]
    },
    {
        path: '**',
        redirectTo: '',
    },
];
